import { render, staticRenderFns } from "./CommentPage.vue?vue&type=template&id=297ec695&scoped=true&"
import script from "./CommentPage.vue?vue&type=script&lang=js&"
export * from "./CommentPage.vue?vue&type=script&lang=js&"
import style0 from "./CommentPage.vue?vue&type=style&index=0&id=297ec695&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297ec695",
  null
  
)

export default component.exports